// var new_date = new Date(
//   new Date().setDate(new Date().getDate() + 30)
// ).toLocaleDateString('en');
const siteTitle = 'Finish your order';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Fill in your information',
    formTitle2: 'You pay here',
    btnForm: 'Continue',
    btnForm2: 'Pay',
    priceText1: 'Payment',
    priceText2: 'Total',
    footerTitle: 'Online payment',
    footerText: 'Confirm with your credit card',
  },
  home: {
    placeholder: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      city: 'City',
      address: 'Address',
      zip: 'ZIP',
      continue: 'Continue',
      name: 'Name',
      confirmPayment: 'Confirm payment',
    },
    cardNumber: 'Card number',
    expirationDate: 'Expiration date',
    name: 'Name',
    month: 'month',
    year: 'year',
    cvv: 'CVV',
    confirmPayment: 'Confirm payment',
    timer: 'Remaining time until payment of the order',
    labelNumber: 'The card number:',
    labelMonth: 'Expiry date:',
    source:
      'We use 3D security to verify your purchase. A new window for transaction verification may appear ',
  },
  validation: {
    requireEmail: 'Your email is empty.',
    validEmail: 'Email is invalid.',
    requirePhone: 'Your Phone is empty.',
    minPhone: 'The phone field must be at least 10 characters.',
    requireFirstName: 'The first name is required.',
    validFirstName: 'The first name is invalid',
    requireLastName: 'The last name field is required.',
    validLastName: 'The last name field is invalid',
    requireCity: 'The city field is required.',
    validCity: 'The city field is invalid',
    requireAddress: 'The address field is required.',
    validAddress: 'The address field is invalid',
    requireZip: 'The zip field is required.',
    validZip: 'The zip field is invalid.',
    requireCard: 'The card number field is required.',
    minCard: 'Not enough symbols.',
    validCard: 'The card number field is invalid.',
    requireMonth: 'The expiration month field is required.',
    requireYear: 'The expiration year field is required.',
    requireName: 'The name field is required.',
    validName: 'The name field is invalid.',
    requireCvv: 'The cvv field is required.',
    validCvv: 'The cvv field is invalid.',
    minFirstName: 'The first name field must be at least 3 characters.',
    minLastName: 'The last name field must be at least 3 characters.',
    minCity: 'The city field must be at least 3 characters.',
    minAddress: 'The address field must be at least 3 characters.',
    minZip: 'The postal code field must be at least 3 characters.',
    minName: 'The name field must be at least 3 characters.',
    minCvv: 'The cvv field must be at least 3 characters.',
    specialFirstName:
      'The field first name must not contain special characters',
    specialLastName: 'The field last name must not contain special characters',
    specialName: 'The field name must not contain special characters',
    specialCity: 'The field city must not contain special characters',
  },
  mask: {
    phone: '+\\966 99 999 99999',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '999',
  },
  getInTouch: {
    title: 'GET IN TOUCH',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-mail',
    msg: 'Message',
    send: 'From you',
    alreadyRegistered: 'You already registered',
    unsubscribeLink: 'Unsubscribe link',
    worktime: 'Call center works from 10am to 5pm',
    phone: 'Phone: Sofia +359 2 437 4207',
  },
};
